import type { IMessageBase } from './base';

export const MESSAGE_TYPE = 'ADDROUTE_CACHEFIRST';

export interface IMessageCacheFirstPayload extends IMessageBase {
    type: 'ADDROUTE_CACHEFIRST';
    payload: {
        matcher: string;
        maxAge: number;
        maxEntries: number;
        cacheName: string;
        ignoreSearch?: boolean;
        fetchOptions?: Partial<RequestInit>;
    };
}
